import { useContext } from 'react';
import { getI18n, I18nContext } from 'react-i18next';
import type { i18n as I18n } from 'i18next';

/**
 * The i18next instance itself, for code that switches the language. The `i18n` that
 * `useTranslation` returns is a copy made per language: it changes identity on every switch
 * (an effect keyed on it switches back and forth without end), and `changeLanguage` called on
 * it sets `language` on the copy, not on the instance the other components read.
 */
export function useI18nInstance(): I18n {
    return useContext(I18nContext)?.i18n ?? getI18n();
}
